module.exports = __webpack_public_path__ + "static/media/musicThumbBoss.f6591927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/musicThumbBoss.png
// module id = 588
// module chunks = 0